import React from 'react';
import { motion } from 'framer-motion';
const results = [{
  id: 1,
  label: 'Brazos',
  src: 'https://cdn.magicpatterns.com/uploads/mazT41dpSzqw9MKSKMn8xb/ChatGPT_Image_11_jun_2026,_15_39_05.png'
}, {
  id: 2,
  label: 'Axilas',
  src: 'https://cdn.magicpatterns.com/uploads/rHSZr9gpfazodprkSsxPYs/ChatGPT_Image_11_jun_2026,_15_38_59.png'
}, {
  id: 3,
  label: 'Piernas',
  src: 'https://cdn.magicpatterns.com/uploads/i2iHSc4BmLPZrLF48zvjne/ChatGPT_Image_11_jun_2026,_15_38_54.png'
}];
export const BeforeAfter = () => {
  return <section className="py-12 sm:py-20 bg-white" data-id="element-13">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-15">
          <h2 className="text-2xl sm:text-3xl font-bold text-navy-900 mb-4" data-id="element-16">
            Resultados Reales
          </h2>
          <p className="text-base sm:text-lg text-slate-600" data-id="element-17">
            La efectividad de la tecnología Soprano visible desde las primeras
            sesiones.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 justify-items-center" data-id="element-18">
          {results.map((item, index) => <motion.figure key={item.id} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group relative w-full max-w-sm mx-auto rounded-2xl overflow-hidden bg-slate-100 border border-slate-200 shadow-sm" data-id="element-19">
              <div className="relative aspect-[2/3]" data-id="element-20">
                <img src={item.src} alt={`Antes y después de depilación láser en ${item.label}`} className="w-full h-full object-cover" data-id="element-21" />

                {/* Top / Bottom labels aligned to the antes / después halves */}
                <div className="absolute top-4 left-4 bg-black/60 backdrop-blur-sm text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-22">
                  ANTES
                </div>
                <div className="absolute bottom-14 left-4 bg-brand-600 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-23">
                  DESPUÉS
                </div>
              </div>

              <figcaption className="absolute bottom-0 inset-x-0 bg-navy-900/85 backdrop-blur-sm text-white text-center font-bold py-3" data-id="element-24">
                {item.label}
              </figcaption>
            </motion.figure>)}
        </div>

        <div className="mt-8 text-center" data-id="element-25">
          <p className="text-xs text-slate-500 italic max-w-md mx-auto leading-relaxed px-4" data-id="element-26">
            Los resultados pueden variar según el tipo de piel
            <br className="sm:hidden" data-id="element-27" /> y vello de cada paciente.
          </p>
        </div>
      </div>
    </section>;
};